module.exports = __webpack_public_path__ + "static/media/animated_sushma.775228f3.png";